import {Component, Input, OnInit, ViewChild, ViewEncapsulation, OnDestroy} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {environment} from '../../../environments/environment';
import {MatSidenav, MatTableDataSource, MatDialog} from '@angular/material';
import {AppComponent} from '../../app.component';
import {BlockTempsComponent} from '../block-temps/block-temps.component';
import {BlockService} from '../../service/BlockService';
import {EmitterService} from '../../service/EmitterService';
import {Router} from '@angular/router';
import * as moment from 'moment';
import { _ } from 'underscore';
import { DATE_DEFAULT_FORMAT, TODAY } from '../../model/commons/DateConstants';
import { ObjectNotificationService } from '../../service/obj-notification.service';
import { LoggerService } from '../../service/LoggerService';
import { DATE_FICHE_LABEL, DATE_DEMANDE_LABEL } from '../../helpers/GlobalConstants';
import { UserService } from '../../service/UserService';
import { ValidateDemandeDialogComponent } from '../block-temps/validate-demande-dialog/validate-demande-dialog.component';
import { OpenFicheService } from '../../service/open-fiche.service';
import {AuthService} from "../../auth/services/auth.service";
import { CroisementVO } from '../../model/CroisementVO';
import { VerroVO } from '../../model/VerroVO';
import { AlertService } from '../../service/alert.service';
import { FormControl } from '@angular/forms';
// import * as visavail from "visavail";
import {FeatureAccessService} from '../../service/feature-access.service';



@Component({
  selector: 'app-intelcia-accordin',
  templateUrl: './intelcia-accordin.component.html',
  styleUrls: ['./intelcia-accordin.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideUpDown', [
      state('0', style({ 'max-height': '*', opacity: 1, display: 'block' })),
      state('1', style({ 'max-height': '0px', opacity: 0, display: 'none' })),
      transition(':enter', animate('100ms ease-in-out')),
      transition('* => *', animate('100ms ease-in-out')),
    ])
  ]
})
export class IntelciaAccordinComponent implements OnInit, OnDestroy {
  payloadHistory = {};
  selectPeriods: any;
  _agent: any;
  displayedColumns = ['demandeur', 'agent', DATE_FICHE_LABEL, DATE_DEMANDE_LABEL, 'status', 'action'];
  dataSource = new MatTableDataSource();
  _timeInsertion: any;
  _export = true;
  isOpened = false;
  hasLoading = true;
  valueDate: any;
  readonly current_date = moment(Date.now()).format('YYYY-MM-DD');
  alertId : any = 'TMA';
  disableAction = false;
  standByMotif=null;

  menuActive = environment.debug.menu;
  public conditionValidationButton= {
    isNow: true,
    isPLanned: false,
    isFULFILLED_INCOHERENCE: false,
    isValidateFULFILLED_INCOHERENCE: false,
    isValidateBreaks: false,
    enableVerroButton: true
  };
  public isLoading = true;
  public demandeToValidateFromHRBP: any;
  demandeToValidateFromHRBP$ = this.objNotificationService.observer$;

  uo: string;
  prioritizedDisplay = false;
  prioritizedSources = [];
  prioritizedSourcesForm =  new FormControl();
  _sources: any;
  @ViewChild(BlockTempsComponent) blockTempsComponent: BlockTempsComponent;
  blockDate: any;

  public openFiche: CroisementVO = {start: '', end: '', matricules: ''};
  public verro: VerroVO = {day: '', durationExp: '', matricules: ''};

  constructor(private auth: AuthService, private app: AppComponent,private dialog: MatDialog, private openFicheservice: OpenFicheService,  private emit: EmitterService, private userService: UserService, public route: Router, private LOG: LoggerService, private blockService: BlockService, private objNotificationService: ObjectNotificationService,private alertService: AlertService) {

  }
  condition(ev) {
    this.conditionValidationButton = ev.condition;
    console.log('conditionValidationButton',this.conditionValidationButton);
    this.isLoading = ev.isLoading
    this.valueDate = ev.valueDate;
  }
  async ngOnInit() {
    this.alertId = this._agent.username;
    this.demandeToValidateFromHRBP$.subscribe(obj => {
      this.demandeToValidateFromHRBP = obj;
      this.LOG.info(`Getting HRBP demande id : ${this.demandeToValidateFromHRBP.id}`);
      this.demandeToValidateFromHRBP.id ? this.dataSource.data.push(this.demandeToValidateFromHRBP) : '';

    },
    error => this.LOG.warn(error),
   () => this.objNotificationService.clearMessages())
    const collaborator = this.userService.getUser('userName');
    const details = await this.auth.getDetailsUser(collaborator);
    const detailsCollaborator = await this.auth.getDetailsUser(this._agent.username);
    this.auth.details = details;
    this.uo = details.uo;
    this.prioritizedDisplay = this.hasPermissionOfPrioitized();
    this.prioritizedDisplay = this.prioritizedDisplay || FeatureAccessService.hasAccessUo('UOS_CURRENT_USER_MERGE_PRIORITIZED_SOURCE',String(this.uo))
      || FeatureAccessService.hasAccessUo('UOS_CURRENT_TIMESHEET_USER_MERGE_PRIORITIZED_SOURCE',String(detailsCollaborator.uo));
    this.prioritizedDisplay = this.prioritizedDisplay || environment.PrioritizedSources.userNames.includes(collaborator);
  }
  @Input()
  public set useExport(v: any) {
    this._export = v;
  }


  @Input()
  public set agent(v: any) {
    this._agent = v;
    this.selectPeriods = this.lastPeriods(v.periods)
    this.selectPeriods ? this.selectPeriods :  this.selectPeriods = [{start: null, end: null}]
  }
  public OpenAccordin() {
      this.isOpened = !this.isOpened;
  }
  public EventMenu(action, user) {
    switch (action) {
      case 'mytrombino': window.open(environment.apps.mytrombino + user.id); break;
      case 'calim': {
        this.app.sidenavCalim.toggle();
      } break;
    }
  }

  lastPeriods(periods: Array<any>) {
      const end_date_is_after_last_day = _d => !_d.end || moment(_d.end).subtract(1, 'days').isSameOrAfter(TODAY);
      const end_date_is_before_last_day = _d => _d.end && moment(_d.end).isSameOrBefore(TODAY);
      let periodsUntilNow = periods && periods.map(_d => {
        if(end_date_is_after_last_day(_d)){
          _d.end = TODAY;
        }
        // if(end_date_is_before_last_day(_d)){
        //   _d.end = TODAY;
        // }
        return _d;
      });
      periodsUntilNow = _.sortBy(periodsUntilNow, 'start').reverse();
      const lastPeriod = periodsUntilNow[0];
      this._agent.periods = periodsUntilNow && periodsUntilNow.slice();
      return lastPeriod;
  }

  validateDemande(element){
    let id = element.id;
    const dialogRef = this.dialog.open(ValidateDemandeDialogComponent, {
      width: '300px !important',
      height: '100px !important',
      panelClass: 'ConfirmationDialog',
      data: {
        from: 'validate',
        id: id,
        callback: (id) => element.isUnlock ?this.openFicheservice.validateUnlockRequest(id) : this.openFicheservice.validateRequest(id)
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.route.navigateByUrl(element.isUnlock?'/process-unlock-requests':'/process-reopen-requests')
    })
  }
  rejectDemande(element){
    let id = element.id;
    const dialogRef = this.dialog.open(ValidateDemandeDialogComponent, {
      width: '300px !important',
      height: '100px !important',
      panelClass: 'ConfirmationDialog',
      data: {
        from: 'reject',
        id: id,
        callback: (id) => element.isUnlock? this.openFicheservice.rejectUnlockRequest(id) :this.openFicheservice.rejectRequest(id)
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.route.navigateByUrl(element.isUnlock?'/process-unlock-requests':'/process-reopen-requests')
    })
  }

  getisPeriod(period, periods) {
    return (period && period.start && periods.length > 0)
  }

  ngOnDestroy(): void {
    this.objNotificationService.clearMessages()
  }
  refresh(valueDate) {
    this.blockDate = valueDate;
    this.blockService.getPrioritizedSources(this._agent.username, valueDate).subscribe((res: any) => {
      res ? this._sources = res.availableSources : this._sources = [];
      res ? this.prioritizedSources = res.selectedSources : this.prioritizedSources = [];
      this.prioritizedSourcesForm.setValue(res.selectedSources);
    });
  }

  updateSources() {
    this.blockTempsComponent.loading = true;
    this.blockService.updatePrioritizedSources(this._agent.username, this.blockDate, this.prioritizedSources)
      .subscribe(() => {
        this.blockTempsComponent.refresh();
    });
  }

  updateSourcesTMA() {
    this.blockTempsComponent.loading = true;
    this.blockService.updatePrioritizedSources(this._agent.username, this.blockDate, this.prioritizedSourcesForm.value).subscribe(() => {
      this.blockTempsComponent.refresh();
    });
  }

  hasPermissionOfPrioitized() {
    const collaborator = this.userService.getUser();
    const  prioritizedSources = environment.PrioritizedSources;
    return Object.keys(prioritizedSources).filter(e => {
      const v = prioritizedSources[e];
      const c = Array.isArray(v) ? v.includes(collaborator[e]) : collaborator[e] == v;
      return collaborator[e] &&  c;
    }).length > 0
  }

  load(value: any) {
    this.hasLoading = value;
    const currentDate = moment(this.blockTempsComponent.valueDate).format(DATE_DEFAULT_FORMAT);
    this.verro.day =currentDate;
    this.verro.matricules =this._agent.username;

    this.openFiche.start = currentDate;
    this.openFiche.end = currentDate
    this.openFiche.matricules= this._agent.username;
    this.getStandBy();
    this.payloadHistory = {};
    if(value) {
      const {newuser, valueDate} = this.blockTempsComponent;
      console.log({newuser, valueDate})
      this.payloadHistory = {userName: newuser , date: valueDate, status: "APPROVED"}
    }
  }
  fire(event: any) {
    if(event.hasOwnProperty("vo")) {
      const {newuser, valueDate} = this.blockTempsComponent;
      const data = JSON.parse(event.vo);
      console.log('data:', data)
      this.blockTempsComponent.loadBlockVersion(data);
      if(event.hasOwnProperty("dispatch")) {
        event.dispatch(false);
      }
    }
  }
  async deVerro() {
    this.blockTempsComponent.loading = true;
    await this.blockService.deVerro(this.verro, () => {}).then((value)=>{
      this.blockTempsComponent.refresh();
      if (!value) {
        this.alertService.error(JSON.stringify(value), this.alertId);
      } else {
        this.alertService.success(JSON.stringify(value), this.alertId);
      }

    })
  }
  async doOpenFiche() {
    this.blockTempsComponent.loading = true;
    await this.blockService.croisement(this.openFiche, () => {}).then((value)=>{
      this.blockTempsComponent.refresh();
      this.disableAction = false;
      if (!value) {
        this.alertService.error(JSON.stringify(value), this.alertId);
      } else {
        this.alertService.success(JSON.stringify(value), this.alertId);
      }
    })
  }
  regenerate(){
    this.blockTempsComponent.loading = true;
    this.blockService.getPlanned(this._agent.username,this.openFiche.start ).subscribe(value => {
      //this.disableAction = false;
      this.blockTempsComponent.refresh();
    })
  }
  async getStandBy(){
    let response= await this.blockService.getStandBy(this._agent.username, moment(this.blockTempsComponent.valueDate).format("YYYY-MM-DD"));
    this.standByMotif = null;
    if(response) {
      if(response.motifStandByDto){
        let motif = response.motifStandByDto.libelle;
        this.standByMotif = motif;
      }
    }
 }
}



// WEBPACK FOOTER //
// ./src/app/view/intelcia-accordin/intelcia-accordin.component.ts